export default "__VITE_ASSET__DRTsU185__"